import { Classification } from '@/classifications/entities/Classification';
import { normalize } from '@/packages/normalizer/normalize';
import { BaseCollection } from './BaseCollection';

/**
 * Permite añadir funcionalidades especificas a un arreglo de javascript
 */
export class Collection extends BaseCollection {

    /**
     * @param {string|Classification} classification - El nombre | el id | La entidad Classification
     * @returns {Collection}
     */
    whereClassification(classification) {
        return this.filter((entity) => {

            if (!classification) {
                return false;
            }

            if (classification instanceof Classification) {
                classification = classification.id;
            }

            return entity.classification_id === classification;
        });
    }

    /**
     * @param {string} name 
     * @returns {Collection}
     */
    whereName(name) {
        return this.filter((entity) => {
            if (!entity.name || !name) {
                return false;
            }
            return normalize(entity.name) === normalize(name);
        });
    }

    /**
     * Permite filtrar por valores de una columna de tabla intermedia
     * 
     * @example
     * ```javascript
     * addresses.wherePivot('classification__id', Classification.EMAIL_ID)
     * ```
     * 
     * @param {string} property - nombre de la columna de la tabla intermedia
     * @param {string} value - valor de la columna buscado
     * @returns {AddressCollection}
     */
    wherePivot(property, value) {
        return this.filter((address) => {
            return address.pivot[property] === value;
        });
    }
}